<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('RegressionTrendTool', function() {
            return {
                group: 'Lines', category: 'Channels', icon: 'line.svg',
                name: 'Regression Trend',
                type: 'Regression',
                hint: 'Linear Regression Channel',
                data: [],
                settings: {}
            }
        }, 'Regression Trend')
</script>
